import { render, staticRenderFns } from "./ItemFilterDocuments.vue?vue&type=template&id=19922868&scoped=true&"
import script from "./ItemFilterDocuments.vue?vue&type=script&lang=js&"
export * from "./ItemFilterDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ItemFilterDocuments.vue?vue&type=style&index=0&id=19922868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19922868",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDatePicker,VDivider})
